import {
  endOfMonth,
  formatISO,
  startOfMonth,
  subDays,
  subMonths,
} from "date-fns";
import { useState } from "react";
import webSocketService from "../../../../../services/WebSocketService";

const LNSends = () => {
  const filterTypeSaved = localStorage.getItem("filterTypeLNSends");
  const fromSaved = localStorage.getItem("fromLNSends");
  const toSaved = localStorage.getItem("toLNSends");
  const savedSelectorValue = filterTypeSaved || "past7";
  const [data, setData] = useState([]);
  const [onChain, setOnChain] = useState([]);
  const [sendCash, setSendCash] = useState([]);
  const [payments, setPayments] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fromDate, setFromDate] = useState(subDays(new Date(), 7));
  const [toDate, setToDate] = useState(new Date());
  const [selectorValue, setSelectorValue] = useState(savedSelectorValue);
  const [showRangePicker, setShowRangePicker] = useState(false);

  const getLNData = async (from, to) => {
    let body = {
      type: "lightning",
      from: formatISO(new Date(from)).slice(0, 19) + "Z",
      to: formatISO(new Date(to)).slice(0, 19) + "Z",
      groupBy: "date",
      currencies: ["USD", "BTC"],
    };

    const onChainData = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      { ...body, subType: "sendOnChain" },
    );
    const sendCashData = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      {
        ...body,
        subType: "sendCash",
      },
    );
    const paymentsData = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      {
        ...body,
        subType: "payments",
      },
    );

    const summarySendsData = {};
    if (onChainData?.grouped) {
      Object.keys(onChainData?.grouped).forEach((el) => {
        if (!summarySendsData[el]) {
          summarySendsData[el] = {};
        }
        summarySendsData[el].onChain = onChainData.grouped[el]?.data;
      });
    }

    if (sendCashData?.grouped) {
      Object.keys(sendCashData?.grouped).forEach((el) => {
        if (!summarySendsData[el]) {
          summarySendsData[el] = {};
        }
        summarySendsData[el].sendCash = sendCashData.grouped[el]?.data;
      });
    }
    if (paymentsData?.grouped) {
      Object.keys(paymentsData?.grouped).forEach((el) => {
        if (!summarySendsData[el]) {
          summarySendsData[el] = {};
        }
        summarySendsData[el].payments = paymentsData.grouped[el]?.data;
      });
    }

    if (typeof totals === "string") {
      setData([]);
    } else {
      localStorage.setItem("filterTypeLNSends", selectorValue);
      localStorage.setItem("fromLNSends", from);
      localStorage.setItem("toLNSends", to);

      setData(summarySendsData);
      setOnChain(onChainData);
      setSendCash(sendCashData);
      setPayments(paymentsData);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const getDateRange = (value) => {
    const today = new Date();
    today.setMinutes(today.getMinutes() + today.getTimezoneOffset());
    let startDate, endDate;

    switch (value) {
      case "thisMonth":
        startDate = startOfMonth(today);
        endDate = today;
        break;
      case "lastMonth":
        const lastMonthDate = subMonths(today, 1);
        startDate = startOfMonth(lastMonthDate);
        endDate = endOfMonth(lastMonthDate);
        break;
      case "past7":
        startDate = subDays(today, 7);
        endDate = today;
        break;
      case "past30":
        startDate = subDays(today, 30);
        endDate = today;
        break;
      case "past90":
        startDate = subDays(today, 90);
        endDate = today;
        break;
      case "all":
        startDate = new Date(2023, 0, 1);
        endDate = today;
        break;
      case "customized":
        startDate = null;
        endDate = null;
        break;
      default:
        startDate = null;
        endDate = null;
    }
    setFromDate(startDate);
    setToDate(endDate);
    return { startDate, endDate };
  };
  return {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    data,
    onChain,
    sendCash,
    payments,
    showRangePicker,
    setSelectorValue,
    getLNData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
  };
};

export default LNSends;
